import AntiphishingError from './AntiphishingError';
class InvestorIsNotRegistered extends AntiphishingError {
    // the value could be trader id or email
    constructor(value, options) {
        super(`The investor '${value}' is not registered`, options);
    }
}
export default InvestorIsNotRegistered;
